var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccurate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#FF7329"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01168 27.8855H18.6093C19.9329 27.8855 20.7239 27.1592 20.7239 25.7581V25.4204C20.7372 21.8394 16.9231 18.9331 15.2491 17.3505C14.7819 16.9093 14.5356 16.5074 14.5356 15.9234C14.5356 15.3394 14.7819 14.9502 15.2497 14.4963C16.9104 12.887 20.7245 10.1629 20.7245 6.43904V6.12793C20.7245 4.72629 19.9329 4 18.6099 4H6.01112C4.71355 4 4 4.72629 4 6.01113V6.43904C4 10.1629 7.81411 12.887 9.48811 14.4963C9.95532 14.9502 10.2017 15.3394 10.2017 15.9234C10.2017 16.5074 9.95532 16.9093 9.48755 17.3505C7.81411 18.9337 4 21.8399 4 25.4204V25.8744C4 27.1587 4.71355 27.8855 6.01112 27.8855M7.36018 26.1085C6.73741 26.1085 6.54311 25.4204 7.15259 24.9665L11.59 21.6578C11.7328 21.5416 11.8103 21.4635 11.8103 21.2687V15.0282C11.8103 14.3274 11.6675 13.977 11.1748 13.5618C10.4353 12.9391 9.03418 11.9532 8.39812 11.058C8.1385 10.6949 8.16452 10.3965 8.48891 10.3965H16.2345C16.5589 10.3965 16.5849 10.6949 16.3253 11.058C15.6898 11.9532 14.3014 12.9391 13.5491 13.5618C13.0564 13.977 12.9131 14.3274 12.9131 15.0282V21.2681C12.9131 21.463 12.9911 21.5405 13.1339 21.6573L17.5841 24.966C18.1936 25.4199 17.986 26.1074 17.3765 26.1074L7.36018 26.1085Z",
    fill: "#011165"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccurate);
export default __webpack_public_path__ + "static/media/accurate.83432719acb99fb74954d0d312c881ff.svg";
export { ForwardRef as ReactComponent };